import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppService } from '@shared/services/core/app.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptionDecryptionService {

  encryptSecretKey = ""; //= "mySecretKeyHere!"; //adding secret key
  encrypted: any = "";
  decrypted: string = "";
  key: any;
  
  constructor(private appService: AppService) {
   // this.encryptSecretKey =environment.encryptSecretKey;
  }
  //Data Encryption Function\
  
  public encryptData(data: string,_encryptSecretKey:string) {
    this.encrypted = CryptoJS.AES.encrypt(data.trim(), _encryptSecretKey.trim()).toString();
    return this.encrypted;
  }
  
  public decrypt(data: string,_encryptSecretKey:string) {
    this.decrypted = CryptoJS.AES.decrypt(data.trim(), _encryptSecretKey.trim()).toString(CryptoJS.enc.Utf8);
    return this.decrypted;
  }

  public generateSecretKey(length: number = 32): string {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?";
    let result = "";
    const values = new Uint32Array(length);
    window.crypto.getRandomValues(values);
    for (let i = 0; i < length; i++) {
      result += charset[values[i] % charset.length];
    }
    return result;
   }
}
